import { LoadableBackground, type LoadableType } from '@confluence/loadable';

import type { PrefetchPublishedSuggestionsProps } from './PrefetchPublishedSuggestions.tsx';

/**
 * Loads the published suggestions prefetch at background priority, the last loading phase, so its
 * request never competes with the page loading.
 */
export const PrefetchPublishedSuggestionsLoader: LoadableType<PrefetchPublishedSuggestionsProps> =
	LoadableBackground({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PrefetchPublishedSuggestions" */ './PrefetchPublishedSuggestions.tsx'
				)
			).PrefetchPublishedSuggestions,
	});
